import React from 'react';
import { createRoot } from 'react-dom/client';
import './theme.css';
import AppRoutes from './router/index';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from './components/ui/Toast';
import { ConfirmProvider } from './components/ui/ConfirmDialog';

/** Após deploy, o browser pode pedir chunks antigos; força 1 reload limpo. */
function isChunkLoadFailure(reason: unknown): boolean {
  const msg =
    reason instanceof Error
      ? `${reason.name} ${reason.message}`
      : String(reason ?? '');
  return /ChunkLoadError|Loading chunk [\d]+ failed|Unexpected token '<'/i.test(
    msg,
  );
}

function reloadOnceForStaleChunk() {
  const key = 'gettudo_chunk_reload';
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');
  const url = new URL(window.location.href);
  url.searchParams.set('_r', String(Date.now()));
  window.location.replace(url.toString());
}

window.addEventListener('error', (event) => {
  if (isChunkLoadFailure(event.error || event.message)) {
    reloadOnceForStaleChunk();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadFailure(event.reason)) {
    reloadOnceForStaleChunk();
  }
});

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <ConfirmProvider>
        <AppRoutes />
      </ConfirmProvider>
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();
